import RoomsTab from './RoomsTab.vue';
export default RoomsTab;
